import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DeviceProvisioningState } from '@iotv/datamodel-core';
import { ComparisonType } from '@iotv/iotv-v3-types';
import { Stack, Switch, Toolbar, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
export const TypeByBooleanAttribute = (props) => {
    const { updateParams: setParamsInParent, keyPress, selected, index, attKey, children } = props;
    const [active, setActive] = useState(true);
    const handleSwitch = () => {
        setActive(!active);
    };
    useEffect(() => {
        if (selected) {
            setParamsInParent([
                { key: attKey, value: false, predicate: active ? ComparisonType.NOT_EQUALS : ComparisonType.EQUALS },
                { key: 'state', value: DeviceProvisioningState.INVENTORY, predicate: ComparisonType.NOT_EQUALS },
            ], index);
        }
        else {
            setParamsInParent(undefined, index);
        }
    }, [active, selected]);
    return (_jsxs(Toolbar, { children: [children, _jsxs(Stack, { direction: "row", spacing: 1, sx: {
                    justifyContent: 'center',
                    alignItems: 'center',
                }, children: [_jsx(Typography, { children: "False" }), _jsx(Switch, { size: "small", checked: active, onChange: handleSwitch, onKeyDown: keyPress }), _jsx(Typography, { children: "True" })] })] }));
};
